module.exports = __webpack_public_path__ + "img/illustrations-spreadsheet.8f5d4957.svg";